import { Component, OnInit } from '@angular/core';
import { EqualValidator } from './../../directives/equal-validator.directive';
import { User } from './user.interface';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { logbaseService } from '../../services/logbase.service';
import { TranslateService } from "@ngx-translate/core";
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  loginId: string;
  payload: {};
  errorMessage: any;
  response: any[];
  constructor(
    private userService: logbaseService,
    private http: HttpClient,
    private toastr: ToastrService,
    private router: Router,
    private translate: TranslateService
  ) { }
  loggedInUser: any;
  userDetail: string;
  public user: User;

  ngOnInit() {

    this.user = {
      username: ''
    }

  }
  postFormError() {
    this.toastr.warning('Problem while Submission, Kindly check your network status');
  }

  save(model: User, isValid: boolean) {
    let resetformData = {
      "userEmailId": model.username
    }
    this.userService.forgotPassword(resetformData.userEmailId).subscribe(

      data => {
        // set success message and pass true paramater to persist the message after redirecting to the login page
        if (data.status.statusMessage == "SUCCESS") {
          this.toastr.info(this.translate.instant('PASSWORD_SENT_EMAIL'));
          this.router.navigate(['/login']);
        }
        else {
          this.toastr.warning(data.status.displayMessage);
        }
      },
      error => {
        this.postFormError();
      });;
  }
}
